import React from 'react';
import cn from 'classnames';

import { ChevronLeft } from '@lt/components/icons-react/rebrand';

import styles from './backButton.module.css';

interface Props {
  onClick?: () => void;
  className?: string;
}

export const BackButton: React.FC<Props> = ({ onClick, className }) => (
  <button
    className={cn(styles.container, className)}
    type="button"
    onClick={onClick}
  >
    <ChevronLeft />
  </button>
);
